import gql from "graphql-tag";
import * as Cookies from "es-cookie";

// Restrictions are read from localStorage across the app ("isStudentUserValid" for
// module/plan access, "globalsubjects" for per-chapter access flags). Those copies
// were only refreshed on some pages, so admin changes needed a logout/login.
// This runs on every full page load (including refresh) to pull the latest values.

const FETCH_ISSTUDENTUSERVALID = gql`
  query($mobile: String) {
    isStudentUserValid(mobile: $mobile) {
      estatus
      current_plan_id
      expiry_date
      user_access_restictions
      module_restrictions
      chapter_ids
    }
  }
`;

const FETCH_CHAPTER_ACCESS = gql`
  query($mobile: String) {
    getSubjects(mobile: $mobile) {
      id
      studentChapters {
        id
        enabled
        linkAnalyEnabled
        customExamsEnabled
        errorExamsEnabled
        revMatrialEnabled
        videoAccess
        chapterPreviousquestionsAccess
      }
    }
  }
`;

const REFRESH_TIMEOUT_MS = 5000;

const readJSON = (key) => {
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch (e) {
    return null;
  }
};

const saveUserValid = (fresh) => {
  if (!fresh) return;
  const current = readJSON("isStudentUserValid") || {};
  localStorage.setItem("isStudentUserValid", JSON.stringify({ ...current, ...fresh }));
};

// Only the access flags are refreshed; the rest of globalsubjects (topics, counts)
// stays as the home page stored it.
const saveChapterAccess = (freshSubjects) => {
  const current = readJSON("globalsubjects");
  if (!Array.isArray(current) || !Array.isArray(freshSubjects)) return;

  const updated = current.map((subject) => {
    const freshSubject = freshSubjects.find((item) => item.id == subject.id);
    if (!freshSubject || !Array.isArray(subject.studentChapters)) return subject;

    return {
      ...subject,
      studentChapters: subject.studentChapters.map((chapter) => {
        const freshChapter = freshSubject.studentChapters.find((item) => item.id == chapter.id);
        if (!freshChapter) return chapter;
        const { __typename, ...flags } = freshChapter;
        return { ...chapter, ...flags };
      }),
    };
  });

  localStorage.setItem("globalsubjects", JSON.stringify(updated));
};

export const refreshStudentSession = (client) => {
  const mobile = Cookies.get("mobile");
  if (Cookies.get("studenttoken") == undefined || !mobile) return Promise.resolve();

  const refresh = Promise.all([
    client
      .query({ query: FETCH_ISSTUDENTUSERVALID, variables: { mobile }, fetchPolicy: "network-only" })
      .then(({ data }) => saveUserValid(data && data.isStudentUserValid))
      .catch((error) => console.log("refreshStudentSession isStudentUserValid", error)),
    client
      .query({ query: FETCH_CHAPTER_ACCESS, variables: { mobile }, fetchPolicy: "network-only" })
      .then(({ data }) => saveChapterAccess(data && data.getSubjects))
      .catch((error) => console.log("refreshStudentSession getSubjects", error)),
  ]);

  // Never hold the app back on a slow network; pages fall back to the stored values.
  const timeout = new Promise((resolve) => setTimeout(resolve, REFRESH_TIMEOUT_MS));

  return Promise.race([refresh, timeout]);
};
